// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_14Yky9W--el0mXdse3owU4"};